import { z } from "zod/v4";

export const GameSchema = z.object({
  gameType: z.string(),
  roomId: z.string(),
  result: z.union([
    z
      .string()
      .nullish()
      .pipe(
        z.transform((val): number[] => {
          if (val) {
            try {
              return JSON.parse(val) as number[];
            } catch (error) {
              console.error(error);
              return [];
            }
          }
          return [];
        }),
      ),
    z.array(z.number()),
  ]),
  gameId: z.string().nullish(),
  state: z.number(),
  time: z.number().nullish(),
  preTime: z.number().nullish(),
  roomName: z.string(),
  preGameId: z.string().nullish(),
  sort: z.number(),
});

export const GameListSchema = z.array(GameSchema);

export const HistoryItemSchema = z.object({
  gameType: z.string(),
  roomId: z.string(),
  gameId: z.string(),
  result: z.union([
    z
      .string()
      .nullish()
      .pipe(
        z.transform((val): number[] => {
          if (val) {
            try {
              return JSON.parse(val) as number[];
            } catch (error) {
              console.error(error);
              return [];
            }
          }
          return [];
        }),
      ),
    z.array(z.number()),
  ]),
  time: z.number(),
  videoUrl: z.string().nullish(),
  imageUrl: z.string().nullish(),
});

export const HistoryListSchema = z.array(HistoryItemSchema);
